import { render } from "./AddTileModal.vue?vue&type=template&id=abb5423e&lang=pug"
import script from "./AddTileModal.vue?vue&type=script&lang=js"
export * from "./AddTileModal.vue?vue&type=script&lang=js"

import "./AddTileModal.vue?vue&type=style&index=0&id=abb5423e&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__